import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { mapModifiersFromTransOrOrderItem } from './mapModifiersFromTransOrOrderItem';
import { CartItemProps } from '../types';

export const castTransItem = (
	transItem: Percomatic.Serialized.TransItem
): CartItemProps => ({
	id: transItem.id,
	modifiers: mapModifiersFromTransOrOrderItem(transItem),
	price: transItem.price,
	product: {
		id: String(transItem.item.product.id),
		name: transItem.item.product.name
	},
	size: transItem.item.size?.name
});
